import { render, staticRenderFns } from "./quiz-options.vue?vue&type=template&id=0bae8312&scoped=true"
import script from "./quiz-options.vue?vue&type=script&lang=ts"
export * from "./quiz-options.vue?vue&type=script&lang=ts"
import style0 from "./quiz-options.vue?vue&type=style&index=0&id=0bae8312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae8312",
  null
  
)

export default component.exports